<div class="container-fluid d-flex align-items-center tapjoidropdown">
  <form [formGroup]="tagSelectForm" style="flex: 1; width: 100%;">
    <!-- <span *ngIf="!viewOnly" style='font-size: 80%; float:right;'><a [routerLink]="" (click)="openTagAddModalDialog()">Add New Tag</a></span> -->
    @if (tagSource != 90) {
      <p-autoComplete appendTo="body" dropdownIcon="fa fa-caret-down"
        [suggestions]="tagSuggestions" [multiple]="true" [forceSelection]="false" [dropdown]="false"
        [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}" [minLength]="1" formControlName="tagJoin"
        unique="true" field="name" placeholder="Search here for Tags" (onSelect)="onSelect($event)"
        (onUnselect)="onUnselect($event)" (onKeyUp)="onKeyUp($event)" [style]="{'width':'100%'}"
        (completeMethod)="onKeyInput($event)">
      </p-autoComplete>
    }

    <!-- For Reservation component -->
    @if (tagSource == 90 && !viewOnly) {
      <button mat-stroked-button type="button"
        (click)="openTagSelectModal()" style="width:100%">
        Search here for Tags
      </button>
    }
    @if (tagSource == 90 && viewOnly) {
      <span class="form-control-plaintext small" style="cursor:default; color:#666;">
        Tags (view only)
      </span>
    }

  </form>
  @if (!viewOnly) {
    <button mat-icon-button type="button" class="add-icon-button" (click)="openTagAddModalDialog()"
      matTooltip="Add New Tag" style="flex-shrink: 0; margin-left: 8px;">
      <mat-icon>add_circle</mat-icon>
    </button>
  }
</div>